export const REDIRECTED_FROM_URL_KEY = 'redirectedFromURL';
